import { CONSTANT } from '@const';
import { AccountType } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class UserAccountService extends ApiService {
	static async getUserAccount(): Promise<AccountType> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.USERS_API_URL,
		};
		return await this.executeApiRequest(params).then((data: AccountType) => {
			return data;
		});
	}

	static async updateUserAccount(userAccount: Partial<AccountType>): Promise<Partial<AccountType>> {
		const params: ApiParams = {
			method: 'PUT',
			url: CONSTANT.USERS_API_URL,
			data: { ...userAccount, contactId: this.getUserId() },
		};
		return await this.executeApiRequest(params);
	}
}
